var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowSelectAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.07227 1.00806L5.10693 1.14771C5.16116 1.36703 5.01359 1.51585 4.22583 2.2832C3.83484 2.66425 3.34811 3.13845 2.95972 3.58044L2.93774 3.60278C2.67621 3.83585 2.43663 4.10174 2.24365 4.31592C2.09492 4.48162 1.96658 4.62244 1.86377 4.71436L1.78442 4.7533C2.09319 5.057 2.54974 5.49293 3.03027 5.95129C5.16407 7.98684 5.16938 8.00367 5.13184 8.19348L5.06592 8.38037L4.92603 8.41431C4.70734 8.46788 4.54558 8.30938 3.72437 7.45862C3.31704 7.03677 2.81063 6.51222 2.32202 6.07178C2.06605 5.79168 1.7772 5.52999 1.54468 5.3197C1.37372 5.16454 1.22685 5.03128 1.12842 4.92529L1.06177 4.80273L1.06055 4.70544L1.06665 4.53735L1.19287 4.46399C1.21946 4.4483 1.25353 4.43466 1.29395 4.43018L1.28906 4.41882L1.40137 4.29834C1.94075 3.71981 2.53889 3.10364 3.28345 2.36011C3.74812 1.89265 4.21362 1.4472 4.67212 1.00964L4.77734 0.908691L5.07227 1.00806Z",
    fill: "#18376D",
    stroke: "#18376D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSelectAll);
export default __webpack_public_path__ + "static/media/left-arrow-select-all.b2206339133eb6b4eed2961f1181b507.svg";
export { ForwardRef as ReactComponent };